<template>
  <el-row :gutter="24" class="feed-cards feed-cards-list">
    <el-col  v-for="item in feeds" :key="item.id" class="feed">
      <el-card shadow="hover" class="feed-card" v-loading="!item.additional">
        <span class="username">{{item.username}}</span>
        <div class="feed-card__header">
          <div>
            <el-tooltip :content="item.threadname" placement="top" effect="light">
              <router-link
                :to="{ name: 'feedAnalytics', params: { threadId: item.id }}"
                class="feed__link"
              >
                {{trimmedTitle(item.threadname)}}
              </router-link>
            </el-tooltip>
            | <span :class="getStatusClass(item.status)">{{getStatus(item.status)}}</span>
          </div>
          <feed-actions
            :threadId="item.id"
            :feed-name="item.threadname"
            :status="item.status"
            @handleFeedDelete="handleFeedDelete"
            @toggleLaunch="toggleLaunch"
            @handleFeedUnpublished="handleFeedUnpublished"
            @handleFeedPublished="handleFeedPublished"
          />
        </div>

        <template v-if="item.additional">
          <post-info :additional="item.additional" :thread-type="threadtype[item.threadtype]"/>
          <feed-info :feed="item"/>
          <feed-chart :feed="item"/>
          <feed-tonal :additional="item.additional" :thread-type="threadtype[item.threadtype]"/>
        </template>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
/*
  feed card component
  use i18n locale
  see http://kazupon.github.io/vue-i18n/started.html for details
*/

// actions
import {GET_ADDITIONAL, RUN_FEED, PAUSE_FEED, GET_FEEDS} from "../../../../store/actions/feeds";

// config

// components
import PostInfo from "./PostInfo";
import FeedInfo from "./FeedInfo";
import FeedChart from "./FeedChart";
import FeedTonal from "./FeedTonal";
import FeedActions from './FeedActions';
import notify from "../../../../helpers/notify";

import { DELETE_FEED, UNPUBLISHED_FEED, PUBLISHED_FEED } from "../../../../store/actions/feeds";

export default {
  name: "FeedCard",
  data() {
    return {
      maxTitleLength: 25,
      pause: "pause",
      threadtype: this.$t('feed.feedType')
    };
  },
  props: {
    feeds: {
      type: Array,
      required: true
    },
    loadAdditional: {
      type: Boolean,
      default: false
    },
    currentPage: {
      type: Number,
      default: 0
    },
    hasSearch: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleLaunch({threadId, status}) {
      let params = {
        id: threadId,
        status: status === 'pause' ? 'run' : 'pause',
      };

      let action = status === 'pause' ? RUN_FEED : PAUSE_FEED;

      this.$store.dispatch(action, params).then(() => {
        notify.call(this,`${this.$t('feed.notify.title')} ${status === 'pause' ? this.$t('feed.notify.launched') : this.$t('feed.notify.stopped')}`, "success");
        this.$store.dispatch(GET_FEEDS);
        this.$emit("currentChange", this.currentPage);
      });
    },
    getStatusClass(status) {
      return status === 'pause' ? 'pauseFeed' : 'playFeed';
    },
    getStatus(status) {
      return status === 'pause' ? this.$t('feed.status[0]') : this.$t('feed.status[1]') ;
    },
    handleFeedDelete(threadId) {
      this.$store.dispatch(DELETE_FEED, {id: threadId}).then(() => {
        notify.call(this, `${this.$t('feed.notify.title')} ${this.$t('feed.notify.delete')}`, "success");
      })
    },
    handleFeedUnpublished(threadId) {
      this.$store.dispatch(UNPUBLISHED_FEED, {id: threadId}).then(() => {
        notify.call(this, `${this.$t('feed.notify.title')} отправлена в архив`, "success");
      })
    },

    handleFeedPublished(threadId) {
      this.$store.dispatch(PUBLISHED_FEED, {id: threadId}).then(() => {
        notify.call(this, `${this.$t('feed.notify.title')} возвращена из архива`, "success");
      })
    },
    isFeedPaused(status){
      return status !== this.pause;
    },
    trimmedTitle(title) {
      if(title.length > this.maxTitleLength) {
        return title.substring(0, this.maxTitleLength) + "...";
      }
      return title;
    },
    getAdditional() {
      if (this.loadAdditional) {
        this.$store.dispatch(GET_ADDITIONAL, this.feeds);
      }
    }
  },
  mounted() {
    this.getAdditional();
  },
  watch: {
    currentPage() {
      this.getAdditional();
    },
    hasSearch(value){
      if (value) {
        this.getAdditional();
      }
    }
  },
  components: {
    PostInfo,
    FeedInfo,
    FeedChart,
    FeedTonal,
    FeedActions,
  }
};
</script>

<style>
.feed-cards {
  margin-bottom: 40px;
}

.feed-card {
  min-height: 260px;
}

.feed-card__header {
  display: flex;
  justify-content: space-between;
}

/*.feeds-card-wrap--users .feed-cards::after {
  display: block;
  margin: 0 12px 20px 12px;
  height: 1px;
  background-color: #DADADA;
  box-sizing: border-box;
  content: "";
}*/

.feed {
  margin-bottom: 20px;
}

.feed__name {
  display: inline-block;
  margin-bottom: 10px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
}

.feed__link,
.feed__link:visited {
  display: inline-block;
  margin-bottom: 10px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  text-decoration: none;
}

.feed__link:hover,
.feed__link:focus,
.feed__link:active {
  color: #1989fa;
}
  .playFeed {
    color: #15CF49;
  }
  .pauseFeed {
    color: #E42E2E;
  }

.username{
  min-height: 20px;
  display: block;
}

@media screen and (max-width: 480px) {
  .feed-cards-list {
    display: flex;
    flex-direction: column;
  }
  .feed {
    width: 100%;
  }

  .feed-card__header {
    flex-direction: column;
    padding-bottom: 10px;
  }
}
</style>
